var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLeafDark = function SvgLeafDark(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 34,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m19.334 12.11-8.797 1.028-2.522 3.707-2.841 9.77 5.363 5.165 3.245-.215 5.552-7.23 1.722-9.298-1.722-2.926Z",
    fill: "#fff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.867 0S4.515 5.284.782 17.005c-2.1 6.597.186 13.234 5.008 14.797 2.409.782 4.678-.078 4.678-.078-2.32-2.347-2.755-7.11-.087-11.54 2.687-4.465 6.629-6.9 9.001-8.107C18.864 6.443 16.741 1.612 15.867 0Z",
    fill: "#479DA6"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M24.798 10.034c-.135.019-2.422.531-5.417 2.044.19 1.904.411 6.245-1.038 10.704-1.498 4.613-4.51 7.78-7.876 8.944 3.417 3.442 9.309 1.294 12.267-3.788 4.667-8.022 2.293-17.059 2.064-17.904Z",
    fill: "#479DA6"
  })));
};
export default SvgLeafDark;